<template>
  <b-container class="mt-5">
    <b-row>
      <b-col cols="6" offset="3">
        <h2>Forgot Password</h2>
        <b-alert show variant="warning" v-if="error">
          <h4 class="alert-heading">Error!!!</h4>
          <p>Oops!!!!, it appears that your username and password are not valid, please try again or contact support</p>
        </b-alert>
        <b-alert show variant="success" v-if="success">
          <h4 class="alert-heading">Success</h4>
          <p>Oops!!!!, it appears that your username and password are not valid, please try again or contact support</p>
        </b-alert>
        <Logo :logoProps="logo" />
        <b-form class="text-left mt-5">
          <b-form-group label="Username" label-cols-sm="4" label-cols-lg="3" label-for="username">
            <b-form-input
              type="email"
              v-model="$v.form.username.$model"
              name="username"
              placeholder="eg. username@ethixbase.com"
              class="form-control"
              :class="{ 'is-invalid': submitted && !form.username }"
              :state="$v.form.username.$dirty ? !$v.form.username.$error : null"
              aria-describedby
            />
            <div v-show="submitted && !form.username" class="invalid-feedback">Username is required</div>
          </b-form-group>
          <b-form-group class="float-right">
             <b-button
              class="mx-2"
              to='/'
              variant="outline-primary"
            >Back</b-button>
            <b-button
              @click="onSubmit"
              :disabled="$v.form.$invalid"
              variant="outline-primary"
            >Reset Password</b-button>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import Logo from "../components/logo/logo.vue";
export default {
  name: "ForgotPage",
  mixins: [validationMixin],
  components: {
    Logo
  },
  data() {
    return {
      logo: {
        width: "auto",
        height: "50px",
        class: "mt-2"
      },
      form: {
        username: null
      },
      error: false,
      success: false,
      submitted: false
    };
  },
  validations: {
    form: {
      username: {
        required,
        minLength: minLength(5)
      }
    }
  },
  methods: {
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      this.alerts();
    },
    alerts() {
      if (this.form.username != "") {
        this.success = true;
      } else {
        this.error = true;
      }
    }
  }
};
</script>

<style>
</style>
